<template>
  <div class="dashboard-container">
    <el-container class="main-container">
      <!-- 左侧导航栏 -->
      <el-aside :width="isCollapse ? '64px' : '220px'" class="aside">
        <div class="logo-container">
          <!-- <img src="../assets/logo.png" alt="系统LOGO" class="logo" /> -->
          <h3 v-if="!isCollapse">院感质控简报系统</h3>
        </div>
        <el-menu
          :default-active="activeMenu"
          class="el-menu-vertical"
          background-color="#304156"
          text-color="#fff"
          active-text-color="#ffd04b"
          :collapse="isCollapse"
          router
        >
          <!-- <el-sub-menu index="1">
            <template #title>
              <el-icon><Document /></el-icon>
              <span>数据录入</span>
            </template>
            <el-menu-item index="/dashboard/mdro-detection">全院多重耐药菌检出情况</el-menu-item>
            <el-menu-item index="/dashboard/mdro-infection">全院多重耐药菌感染情况</el-menu-item>
            <el-menu-item index="/dashboard/mdro-isolation">MDRO患者接触隔离医嘱开具情况</el-menu-item>
            <el-menu-item index="/dashboard/mdro-department">MDRO各科室检出例数汇总</el-menu-item>
          </el-sub-menu> -->
          
          <el-sub-menu index="2">
            <template #title>
              <el-icon><Document /></el-icon>
              <span>数据录入</span>
            </template>
            <el-menu-item index="/dashboard/infection-statistic">医院感染发病率监测</el-menu-item>
            <el-menu-item index="/dashboard/ISurgery">I类切口手术部位感染及预防性抗菌药物使用情况</el-menu-item>
            <el-menu-item index="/dashboard/antibacterialDrugs">抗菌药物治疗前病原学送检率监测</el-menu-item>
            <el-menu-item index="/dashboard/mdro-statistic">多重耐药菌监测</el-menu-item>
            <el-menu-item index="/dashboard/icusg-statistic">ICU"三管"相关感染监测</el-menu-item>
            <el-menu-item index="/dashboard/nicu-statistic">NICU医院感染监测</el-menu-item>
            <el-menu-item index="/dashboard/eicu-statistic">EICU医院感染监测</el-menu-item>
            <el-menu-item index="/dashboard/surgeryTarget-statistic">手术部位感染目标性监测</el-menu-item>
            <el-menu-item index="/dashboard/hospital-three-tube-monitor">全院三管相关感染监测</el-menu-item>
            <el-menu-item index="/dashboard/blood-infection-monitor">血液感染及血源性病原体监测</el-menu-item>
            <!-- <el-menu-item index="/dashboard/target-statistic">目标性监测统计</el-menu-item>
            <el-menu-item index="/dashboard/surgery-statistic">手术部位感染统计</el-menu-item> -->
            <el-menu-item index="/dashboard/hand-hygiene-compliance-statistic">手卫生依从性自查统计</el-menu-item>
            <el-menu-item index="/dashboard/hand-hygiene-form1">手卫生操作考核评分表1(洗手与卫生手消毒)</el-menu-item>
            <el-menu-item index="/dashboard/hand-hygiene-form3">手卫生操作考核评分表2(外科手消毒)</el-menu-item>
            <el-menu-item index="/dashboard/hand-hygiene1">手卫生依从性调查表</el-menu-item>
          </el-sub-menu>
          
          <el-sub-menu index="3">
            <template #title>
              <el-icon><DataAnalysis /></el-icon>
              <span>数据分析与统计</span>
            </template>
            <el-menu-item index="/analysis/surgery">Ⅰ类切口手术部位感染率分析</el-menu-item>
            <el-menu-item index="/analysis/infection">感染率分析</el-menu-item>
            <!-- <el-menu-item index="/analysis/mdro">多重耐药菌分析</el-menu-item> -->
            <el-menu-item index="/analysis/monitor">全院三管相关感染监测分析</el-menu-item>
            <el-menu-item index="/analysis/antibiotics">抗菌药物治疗前病原学送检率分析</el-menu-item>
            <el-menu-item index="/analysis/handHygiene">手卫生依从率分析</el-menu-item>
          </el-sub-menu>
          
          <el-sub-menu index="4">
            <template #title>
              <el-icon><Bell /></el-icon>
              <span>预警与提醒</span>
            </template>
            <el-menu-item index="/alert/rules">预警规则配置</el-menu-item>
            <el-menu-item index="/alert/records">预警记录</el-menu-item>
            <!-- <el-menu-item index="/alert/follow">整改跟踪</el-menu-item> -->
          </el-sub-menu>
          
          <el-sub-menu index="5">
            <template #title>
              <el-icon><Monitor /></el-icon>
              <span>督查与整改管理</span>
            </template>
            <el-menu-item index="/supervision/InfectionControlInspectiors">感染管理质控督查表</el-menu-item>
            <!-- <el-menu-item index="/supervision/tasks">督查任务</el-menu-item>
            <el-menu-item index="/supervision/records">督查记录</el-menu-item>
            <el-menu-item index="/supervision/implement">整改落实</el-menu-item> -->
          </el-sub-menu>
        </el-menu>
      </el-aside>
      
      <!-- 右侧主内容区 -->
      <el-container class="main-content">
        <!-- 顶部导航栏 -->
        <el-header height="60px" class="header">
          <div class="header-left">
            <el-icon class="fold-btn" @click="toggleSidebar">
              <component :is="isCollapse ? 'Expand' : 'Fold'" />
            </el-icon>
            <el-breadcrumb separator="/">
              <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>{{ currentRoute }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="header-right">
            <el-dropdown trigger="click">
              <div class="avatar-container">
                <el-avatar :size="36" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" />
                <span class="username">{{ username }}</span>
                <el-icon><CaretBottom /></el-icon>
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item>个人中心</el-dropdown-item>
                  <el-dropdown-item>修改密码</el-dropdown-item>
                  <el-dropdown-item divided @click="logout">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </el-header>
        
        <!-- 内容区域 -->
        <el-main class="main">
          <div class="welcome-container" v-if="isHomePage">
            <h1>欢迎使用医院感染质控简报系统</h1>
            <div class="overview-cards">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-card shadow="hover" class="overview-card clickable-card" @click="navigateToInfectionStatistic">
                    <template #header>
                      <div class="card-header">
                        <span>医院感染数据</span>
                        <el-icon><DataLine /></el-icon>
                      </div>
                    </template>
                    <div class="card-content">
                      <div class="card-value">{{ dashboardData.infectionCount }}</div>
                      <div class="card-subtitle">本季度感染人数</div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover" class="overview-card clickable-card" @click="navigateToSurgeryStatistic">
                    <template #header>
                      <div class="card-header">
                        <span>Ⅰ类切口手术</span>
                        <el-icon><Warning /></el-icon>
                      </div>
                    </template>
                    <div class="card-content">
                      <div class="card-value">{{ dashboardData.surgeryInfectionCount }}</div>
                      <div class="card-subtitle">本季度Ⅰ类切口手术感染人数</div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover" class="overview-card clickable-card" @click="navigateToAlertRecords">
                    <template #header>
                      <div class="card-header">
                        <span>预警消息</span>
                        <el-icon><Bell /></el-icon>
                      </div>
                    </template>
                    <div class="card-content">
                      <div class="card-value">{{ dashboardData.alertCount }}</div>
                      <div class="card-subtitle">待处理预警</div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="6">
                  <el-card shadow="hover" class="overview-card clickable-card" @click="navigateToSupervisionTasks">
                    <template #header>
                      <div class="card-header">
                        <span>督查任务</span>
                        <el-icon><Check /></el-icon>
                      </div>
                    </template>
                    <div class="card-content">
                      <div class="card-value">{{ dashboardData.inspectCount }}</div>
                      <div class="card-subtitle">总督查任务</div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
            <div class="charts-container">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-card shadow="hover" class="chart-card">
                    <template #header>
                      <div class="card-header">
                        <span>全院感染率趋势</span>
                      </div>
                    </template>
                    <div class="chart" id="infection-trend-chart"></div>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card shadow="hover" class="chart-card">
                    <template #header>
                      <div class="card-header">
                        <span>科室感染分布</span>
                      </div>
                    </template>
                    <div class="chart" id="department-infection-chart"></div>
                  </el-card>
                </el-col>
              </el-row>
            </div>
          </div>
          <router-view v-else />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import * as echarts from 'echarts'
import { getHospitalInfectionList } from '@/api/hospitalInfection'
import { 
  getAlertRecordsList, 
  getAlertRecordsByStatus,
} from '@/api/alertRecords'
import { getWardList } from '@/api/ward'
import { getOneSurveryList } from '@/api/oneSurvery'
import { getAllInfectionManagement } from '@/api/infectionManagement'

// 解构需要使用的图标
const { 
  Edit, 
  Document, 
  DataAnalysis, 
  Bell, 
  Monitor, 
  Fold, 
  Expand, 
  CaretBottom, 
  DataLine, 
  Warning, 
  Check
} = ElementPlusIconsVue

const store = useStore()
const router = useRouter()
const route = useRoute()

// 用户信息
const username = computed(() => store.state.user?.name || '管理员')

// 控制侧边栏
const isCollapse = ref(false)
const toggleSidebar = () => {
  isCollapse.value = !isCollapse.value
  // 折叠后需要重新调整图表大小
  if (isHomePage.value) {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 300)
  }
}

// 当前路由
const activeMenu = ref('/dashboard')
const currentRoute = computed(() => {
  const pathMap = {
    '/dashboard': '首页',
    // 数据录入
    '/dashboard/infection-statistic': '医院感染发病率监测',
    '/dashboard/ISurgery': 'I类切口手术部位感染及预防性抗菌药物使用情况',
    '/dashboard/antibacterialDrugs': '抗菌药物治疗前病原学送检率',
    '/dashboard/mdro-statistic': '多重耐药菌监测',
    '/dashboard/icusg-statistic': 'ICU“三管”相关感染监测',
    '/dashboard/nicu-statistic': 'NICU医院感染监测',
    '/dashboard/eicu-statistic': 'EICU医院感染监测',
    '/dashboard/surgeryTarget-statistic': '手术部位感染目标性监测',
    '/dashboard/hospital-three-tube-monitor': '全院"三管"相关感染监测',
    '/dashboard/blood-infection-monitor': '门诊血液感染事件及血源性病原体监测',
    '/dashboard/hand-hygiene-compliance-statistic': '手卫生依从性统计',
    '/dashboard/hand-hygiene-form1': '手卫生操作考核评分表1(洗手与卫生手消毒)',
    '/dashboard/hand-hygiene-form2': '手卫生操作考核评分表2(手部卫生)',
    '/dashboard/hand-hygiene1': '手卫生依从性调查表',
    // 数据分析与统计
    '/analysis/surgery': 'Ⅰ类切口手术部位感染率分析',
    '/analysis/infection': '医院感染率分析',
    '/analysis/monitor': '全院三管相关感染监测分析',
    '/analysis/antibiotics': '抗菌药物治疗前送检率分析',
    '/analysis/handHygiene': '手卫生依从率分析',
    // 预警与提醒
    '/alert/rules': '预警规则配置',
    '/alert/records': '预警记录',
    // 督察与整改管理
    '/supervision/InfectionControlInspectiors': '感染管理质控督查表'
  }
  return pathMap[route.path] || '首页'
})

// 判断是否为首页
const isHomePage = computed(() => route.path === '/dashboard')

// 响应式数据
// 修改dashboardData的定义
const dashboardData = ref({
  infectionCount: 0,        // 本季度感染人数
  surgeryInfectionCount: 0, // 本季度Ⅰ类切口手术感染人数
  alertCount: 0,            // 待处理预警（统一命名）
  inspectCount: 0           // 督查任务总数
})

const infectionTrendData = ref({
  months: [],
  infectionRates: [],
  alertProcessRates: []
})

const departmentData = ref([])

// 获取当前季度的月份列表
const getCurrentQuarterMonths = () => {
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const quarter = Math.ceil(month / 3)
  
  const quarterMonths = {
    1: ['01', '02', '03'],
    2: ['04', '05', '06'],
    3: ['07', '08', '09'],
    4: ['10', '11', '12']
  }
  
  return quarterMonths[quarter].map(m => `${year}-${m}`)
}

// 获取当前季度
function getCurrentQuarter() {
  const now = new Date()
  const year = now.getFullYear()
  const month = now.getMonth() + 1
  const quarter = Math.ceil(month / 3)
  
  let startMonth, endMonth
  switch (quarter) {
    case 1:
      startMonth = 1
      endMonth = 3
      break
    case 2:
      startMonth = 4
      endMonth = 6
      break
    case 3:
      startMonth = 7
      endMonth = 9
      break
    case 4:
      startMonth = 10
      endMonth = 12
      break
    default:
      startMonth = 1
      endMonth = 3
  }
  
  const startDate = `${year}-${String(startMonth).padStart(2, '0')}-01 00:00:00`
  const endDate = new Date(year, endMonth, 0)
  const lastDay = endDate.getDate()
  const endDateStr = `${year}-${String(endMonth).padStart(2, '0')}-${String(lastDay).padStart(2, '0')} 23:59:59`
  
  return { startDate, endDate: endDateStr, quarter, year }
}

// 获取本季度Ⅰ类切口手术感染数据
async function loadSurgeryInfectionData() {
  try {
    const { startDate, endDate } = getCurrentQuarter()
    
    const params = {
      current: 1,
      size: 1000, // 获取所有数据
      startDate,
      endDate
    }
    
    console.log('查询Ⅰ类切口手术感染数据参数:', params)
    
    const res = await getOneSurveryList(params)
    if (res.code === 200) {
      const list = res.data.list || []
      
      // 只统计总感染人数
      let totalInfectionCount = 0
      
      list.forEach(item => {
        totalInfectionCount += Number(item.totalSurgeryInfect || 0)
      })
      
      console.log(`本季度Ⅰ类切口手术感染总人数: ${totalInfectionCount}人`)
      
      return totalInfectionCount
    } else {
      console.error('获取Ⅰ类切口手术感染数据失败:', res.message)
      return 0
    }
  } catch (error) {
    console.error('获取Ⅰ类切口手术感染数据异常:', error)
    return 0
  }
}

// 参考InfectionStatistic.vue的数据查询逻辑
const loadDashboardData = async () => {
  try {
    const quarterMonths = getCurrentQuarterMonths()
    let totalInfectionCount = 0
    
    // 获取本季度每个月的医院感染数据
    for (const month of quarterMonths) {
      try {
        const res = await getHospitalInfectionList({
          statDate: month,
          currentPage: 1,
          pageSize: 9999
        })
        
        if (res.code === 200 && res.data.list) {
          // 累计感染人数（参考InfectionStatistic.vue的计算逻辑）
          const monthlyInfectionCount = res.data.list.reduce((sum, ward) => {
            return sum + (ward.newInfectionCasesCount || 0)
          }, 0)
          
          totalInfectionCount += monthlyInfectionCount
        }
      } catch (error) {
        console.error(`获取${month}数据失败:`, error)
      }
    }
    
    // 获取本季度Ⅰ类切口手术感染总人数
    const surgeryInfectionCount = await loadSurgeryInfectionData()
    
    // 直接查询数据库中未处理的预警记录
    let pendingAlertsCount = 0
    try {
      // 方法1：使用状态查询未处理的预警（推荐）
      const pendingAlerts = await getAlertRecordsByStatus('待处理')
      if (pendingAlerts.code === 200) {
        pendingAlertsCount = Array.isArray(pendingAlerts.data) ? pendingAlerts.data.length : (pendingAlerts.data?.total || 0)
      }
      
      
      console.log(`查询到待处理预警数量: ${pendingAlertsCount}`)
      
    } catch (error) {
      console.error('获取待处理预警数据失败:', error)
      pendingAlertsCount = 0
    }
    
    // 在loadDashboardData函数中，在获取预警数据之后添加以下代码：
    
    // 获取督查任务数据
    let inspectTaskCount = 0
    try {
      const inspectRes = await getAllInfectionManagement()
      if (inspectRes.code === 200) {
        // 统计督查任务总数量
        if (Array.isArray(inspectRes.data)) {
          inspectTaskCount = inspectRes.data.length
        } else if (inspectRes.data && typeof inspectRes.data === 'object') {
          // 如果返回的是分页数据结构
          inspectTaskCount = inspectRes.data.total || (inspectRes.data.list ? inspectRes.data.list.length : 0)
        }
        
        console.log(`查询到督查任务数量: ${inspectTaskCount}`)
      } else {
        console.error('获取督查任务数据失败:', inspectRes.message)
      }
    } catch (error) {
      console.error('获取督查任务数据异常:', error)
      inspectTaskCount = 0
    }
    
    // 更新仪表板数据（修改原有的更新逻辑）
    dashboardData.value.infectionCount = totalInfectionCount
    dashboardData.value.surgeryInfectionCount = surgeryInfectionCount
    dashboardData.value.alertCount = pendingAlertsCount  // 注意：原来是pendingAlerts，建议统一命名
    dashboardData.value.inspectCount = inspectTaskCount  // 新增督查任务数量
    
    console.log('仪表板数据加载完成:', dashboardData.value)
    
  } catch (error) {
    console.error('加载仪表板数据失败:', error)
  }
}

// 参考InfectionStatistic.vue加载感染率趋势数据
const loadInfectionTrendData = async () => {
  try {
    const now = new Date()
    const year = now.getFullYear()
    const months = []
    const infectionRates = []
    const alertProcessRates = []
    
    // 获取最近6个月的数据
    for (let i = 5; i >= 0; i--) {
      const date = new Date(year, now.getMonth() - i, 1)
      const monthStr = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
      const monthLabel = `${date.getMonth() + 1}月`
      
      try {
        const res = await getHospitalInfectionList({
          statDate: monthStr,
          currentPage: 1,
          pageSize: 9999
        })
        
        if (res.code === 200 && res.data.list) {
          // 计算全院感染率（参考InfectionStatistic.vue的计算逻辑）
          const totalHospitalCount = res.data.list.reduce((sum, ward) => sum + (ward.hospitalCount || 0), 0)
          const totalInfectionCount = res.data.list.reduce((sum, ward) => sum + (ward.newInfectionCasesCount || 0), 0)
          
          const infectionRate = totalHospitalCount > 0 ? (totalInfectionCount / totalHospitalCount) * 1000 : 0
          
          months.push(monthLabel)
          infectionRates.push(Number(infectionRate.toFixed(2)))
          
          // 这里可以添加预警处理率的计算逻辑
          alertProcessRates.push(Math.floor(Math.random() * 10) + 85) // 临时数据
        } else {
          months.push(monthLabel)
          infectionRates.push(0)
          alertProcessRates.push(0)
        }
      } catch (error) {
        console.error(`获取${monthStr}趋势数据失败:`, error)
        months.push(monthLabel)
        infectionRates.push(0)
        alertProcessRates.push(0)
      }
    }
    
    infectionTrendData.value = {
      months,
      infectionRates,
      alertProcessRates
    }
    
  } catch (error) {
    console.error('加载感染趋势数据失败:', error)
    // 使用默认数据
    infectionTrendData.value = {
      months: ['1月', '2月', '3月', '4月', '5月', '6月'],
      infectionRates: [3.2, 3.5, 3.8, 4.1, 3.9, 3.6],
      alertProcessRates: [87, 92, 88, 93, 90, 94]
    }
  }
}

// 参考InfectionStatistic.vue加载科室数据 - 修改为使用本季度数据
const loadDepartmentData = async () => {
  try {
    // 获取病区列表
    const wardRes = await getWardList()
    let wardOptions = []
    if (Array.isArray(wardRes)) {
      wardOptions = wardRes
    } else if (wardRes && Array.isArray(wardRes.data)) {
      wardOptions = wardRes.data
    }
    
    // 获取本季度的月份列表
    const quarterMonths = getCurrentQuarterMonths()
    const departmentInfectionMap = new Map()
    
    // 累计本季度每个月的科室感染数据
    for (const month of quarterMonths) {
      try {
        const res = await getHospitalInfectionList({
          statDate: month,
          currentPage: 1,
          pageSize: 9999
        })
        
        if (res.code === 200 && res.data.list) {
          res.data.list.forEach(row => {
            const wardKey = row.wardId || row.wardName
            const wardName = row.wardName
            const infectionCount = row.newInfectionCasesCount || 0
            
            if (departmentInfectionMap.has(wardKey)) {
              departmentInfectionMap.get(wardKey).value += infectionCount
            } else {
              departmentInfectionMap.set(wardKey, {
                value: infectionCount,
                name: wardName
              })
            }
          })
        }
      } catch (error) {
        console.error(`获取${month}科室数据失败:`, error)
      }
    }
    
    // 转换为数组并过滤有效数据
    const quarterDepartmentData = Array.from(departmentInfectionMap.values())
      .filter(item => item.value > 0) // 只显示有感染数据的科室
      .sort((a, b) => b.value - a.value) // 按感染数量降序排列
      .slice(0, 6) // 取前6个
    
    departmentData.value = quarterDepartmentData.length > 0 ? quarterDepartmentData : [
      { value: 42, name: 'ICU' },
      { value: 38, name: '内科' },
      { value: 35, name: '外科' },
      { value: 25, name: '妇产科' },
      { value: 20, name: '儿科' },
      { value: 18, name: '其他' }
    ]
    
    console.log('本季度科室感染分布数据:', departmentData.value)
    
  } catch (error) {
    console.error('加载科室数据失败:', error)
    // 使用默认数据
    departmentData.value = [
      { value: 42, name: 'ICU' },
      { value: 38, name: '内科' },
      { value: 35, name: '外科' },
      { value: 25, name: '妇产科' },
      { value: 20, name: '儿科' },
      { value: 18, name: '其他' }
    ]
  }
}

// 初始化图表
const initCharts = () => {
  // 感染率趋势图
  const infectionTrendChart = echarts.init(document.getElementById('infection-trend-chart'))
  infectionTrendChart.setOption({
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['感染率', '预警处理率']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: infectionTrendData.value.months,
      axisLabel: {
        interval: 0,
        rotate: 45,        // 45度旋转标签
        fontSize: 12       // 调整字体大小
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        formatter: '{value}%'
      }
    },
    series: [
      {
        name: '感染率',
        type: 'line',
        data: infectionTrendData.value.infectionRates,
        itemStyle: {
          color: '#409EFF'
        }
      },
      {
        name: '预警处理率',
        type: 'line',
        data: infectionTrendData.value.alertProcessRates,
        itemStyle: {
          color: '#67C23A'
        }
      }
    ]
  })
  
  // 科室感染分布图
  const departmentInfectionChart = echarts.init(document.getElementById('department-infection-chart'))
  departmentInfectionChart.setOption({
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 10,
      data: departmentData.value.map(item => item.name)
    },
    series: [
      {
        name: '感染例数',
        type: 'pie',
        radius: ['50%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: departmentData.value
      }
    ]
  })
  
  // 窗口大小变化时重设图表大小
  window.addEventListener('resize', () => {
    infectionTrendChart.resize()
    departmentInfectionChart.resize()
  })
}

// 导航方法
const navigateToInfectionStatistic = () => {
  router.push('/dashboard/infection-statistic')
}

const navigateToSurgeryStatistic = () => {
  router.push('/dashboard/ISurgery')
}

const navigateToAlertRecords = () => {
  router.push('/alert/records')
}

const navigateToSupervisionTasks = () => {
  router.push('/supervision/InfectionControlInspectiors')
}

// 退出登录
const logout = () => {
  store.dispatch('logout')
  router.push('/')
}

// 添加路由监听，当路由变化时重新初始化图表
watch(
  () => route.path,
  async (newPath) => {
    if (newPath === '/dashboard') {
      // 等待DOM更新完成
      await nextTick()
      
      // 重新加载数据和初始化图表
      await loadDashboardData()
      await loadInfectionTrendData()
      await loadDepartmentData()
      
      // 延迟初始化图表，确保DOM元素已渲染
      setTimeout(() => {
        initCharts()
      }, 200)
    }
  },
  { immediate: false }
)

// 组件挂载时初始化
onMounted(async () => {
  if (isHomePage.value) {
    // 加载仪表板数据
    await loadDashboardData()
    
    // 加载图表数据
    await loadInfectionTrendData()
    await loadDepartmentData()
    
    // 初始化图表
    setTimeout(() => {
      initCharts()
    }, 100)
  }
})
</script>

<style scoped>
.dashboard-container {
  height: 100vh;
  overflow: hidden;
}

.main-container {
  height: 100%;
}

.aside {
  background-color: #304156;
  color: #fff;
  transition: width 0.3s ease;
  height: 100%;
  overflow-x: hidden;
}

.logo-container {
  height: 60px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  border-bottom: 1px solid #1f2d3d;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.3s;
}

.logo {
  width: 32px;
  height: 32px;
  margin-right: 10px;
  transition: margin 0.3s;
}

.el-menu-vertical {
  border-right: none;
  transition: width 0.3s;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 220px;
}

.header {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.header-left {
  display: flex;
  align-items: center;
}

.fold-btn {
  cursor: pointer;
  font-size: 20px;
  margin-right: 20px;
  transition: transform 0.3s;
}

.header-right {
  display: flex;
  align-items: center;
}

.avatar-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.username {
  margin: 0 8px;
  color: #606266;
}

.main {
  background-color: #f0f2f5;
  padding: 20px;
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.welcome-container {
  width: 100%;
}

.welcome-container h1 {
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
}

.overview-cards {
  margin-bottom: 30px;
}

.overview-card {
  transition: all 0.3s;
}

.overview-card:hover {
  transform: translateY(-5px);
}

.clickable-card {
  cursor: pointer;
  transition: all 0.3s ease;
}

.clickable-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.overview-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
}

.card-content {
  text-align: center;
}

.card-value {
  font-size: 32px;
  font-weight: bold;
  color: #409EFF;
  margin-bottom: 8px;
}

.card-subtitle {
  color: #909399;
  font-size: 14px;
}

.charts-container {
  margin-top: 20px;
}

.chart-card {
  height: 500px; /* 原来是400px，增加100px */
  margin-bottom: 20px;
}

.chart {
  height: 440px; /* 原来是340px，增加100px */
}
</style>



